import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { Spinner, Stack } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { getStrictCurrentEnterpriseId } from '@mews-commander/core';
import { GeneralArea, GeneralSignInMethod, useRepositoryMutation } from '@mews-commander/data-access';
import { LocalizedParagraph } from '@mews-commander/ui';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import {
    checkForConsent,
    getDeviceFingerprintPayload,
    INITIAL_SIGN_IN_PARAMS,
    initializeUserSession,
} from '../../ducks/actions';
import { deleteLockedUser } from '../SignInAndLockscreen/Lockscreen/useLockscreenStore';

export const SsoRedirect = () => {
    const navigate = useNavigate();
    const dispatch = useCommanderThunkDispatch();
    const { mutateAsync: signIn } = useRepositoryMutation('generalUsers', 'signIn', {
        onSuccess: (data) => {
            if (!data.accessInfo?.user.id) {
                return;
            }
            deleteLockedUser(data.accessInfo?.user.id);
        },
    });

    useEffect(() => {
        signIn({
            ...INITIAL_SIGN_IN_PARAMS,
            device: getDeviceFingerprintPayload(),
            method: GeneralSignInMethod.SignInToken,
            application: GeneralArea.Commander,
        })
            .then(async (data) => dispatch(checkForConsent(data)))
            .then(async (data) => dispatch(initializeUserSession(data)))
            .then(async () => {
                const currentEnterpriseId = getStrictCurrentEnterpriseId();
                await navigate({ to: '/$currentEnterpriseId/Dashboard/Index', params: { currentEnterpriseId } });
            })
            .catch(async () => navigate({ to: '/Home/SignIn' }));
    }, [dispatch, signIn, navigate]);

    return (
        <Stack alignment="center" itemAlignment="center" fill>
            <Stack vertical itemAlignment="center" spacing="100">
                <Spinner />
                <LocalizedParagraph textKey={TextKey.LoggingInWithSso} />
            </Stack>
        </Stack>
    );
};
